export default "__VITE_ASSET__DvHEXHVA__"